<template>
  <div class="icon-wrap" @click="loginWithDiscord()">
    <div class="login"></div>
  </div>
</template>

<script>
export default {
  name: 'DiscordLogin',
  data () {
    return {
      userInfo: {},
      isRepeat: false,
      clientId: '',
      redirectUri: window.location.origin,
      scope: 'identify email',
      state: '',
      oauthkey: ''
    }
  },
  created () {
    const gid = JSON.parse(window.localStorage.getItem('sdkParams') || '{}').gid
    this.clientId = this.$ENUM.DISCORD_ACCOUNT_MAP[gid]
    
    const urlParams = this.$utils.getParamsFromUrl(true)
    this.state = this.$utils.getSocialOauthState({
      platform: 'discord',
      oauthtype: urlParams.oauthtype || '',
      gid: urlParams.gid,
      game_project: urlParams.game_project,
      lang: urlParams.lang,
      passportSDK: this.$route.name === 'OauthFPXLogin' ? 'FPX' : ''
    })
  },
  methods: {
    onDiscordLogin () {
      this.$utils.log('pc_login_action', {
        login_action: 'click_discord'
      })

      const authUrl = `https://discord.com/api/oauth2/authorize?client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&response_type=token&scope=${this.scope}&state=${this.state}`
      
      // 使用 implicit grant flow，直接在URL中返回access token
      window.location.href = authUrl
    },
    loginWithDiscord() {
      this.oauthkey = new Date().getTime()
      localStorage.setItem('discordKey', this.oauthkey)
      const authUrl = `https://discord.com/oauth2/authorize?client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&response_type=token&scope=${this.scope}&state=${this.state}`;

      // 打开 Discord OAuth 弹窗
      const popup = window.open(authUrl, "_blank", "width=500,height=600");

      // 监听弹窗关闭事件
      const interval = setInterval(() => {
        if (popup.closed) {
          clearInterval(interval);
          console.log("弹窗关闭，开始处理登录状态...");
          // 可以在这里轮询或者回调处理登录信息
          this.getMe()
        }
      }, 1000);
    },

    async getMe () {
      const accessToken = this.getAccessTokenFromUrl()
      if(!accessToken) return this.$msg.success(this.$t('login_fail_2'))
      try {
        const response = await fetch('https://discord.com/api/users/@me', {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })

        const userData = await response.json()
        
        this.userInfo = {
          id: userData.id,
          name: userData.username,
          email: userData.email,
          token: accessToken,
          type: this.$ENUM.SOCIAL_MAP.DISCORD,
          expire: 604800 // Discord token 默认7天过期
        }
        
        this.login()
      } catch (error) {
        console.log('Discord login Error: ', error)
        this.$msg.success(this.$t('login_fail_2'))
      }
    },
    login () {
      this.$emit("success", { ...this.userInfo })
    },
    getAccessTokenFromUrl() {
      const key = localStorage.getItem('discordToken').split('__')
      if (key[0] === localStorage.getItem('discordKey')) {
        return key[1]
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang='less' scoped >
.icon-wrap {
  width: 32px;
  height: 32px;
  background-color: white;
  border: 1px solid #dadce0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  .login {
    width: 100%;
    height: 100%;
    background: url(~@img/icon_discord.png) center center no-repeat;
    background-size: auto 50%;
  }
}
</style>
